/*
*  Blog posts. Every .js file in ./posts is a post - see ./posts/_TEMPLATE.txt for how to add one
*/
import { marked } from "marked";

const WORDS_PER_MINUTE = 200;

//Plain text version of the markdown body (for excerpts and the reading time)
const toPlainText = (markdown) => markdown
  .replace(/!\[[^\]]*\]\([^)]*\)/g, "") //Images
  .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1") //Links - keep the text
  .replace(/[#>*_`~-]+/g, " ")
  .replace(/\s+/g, " ")
  .trim();

const makeExcerpt = (text, length = 160) => {
  if (text.length <= length) {
    return text;
  }
  return `${text.slice(0, text.lastIndexOf(" ", length))}...`;
};

//require.context is resolved by webpack at build time, so new post files are picked up automatically
const context = require.context("./posts", false, /\.js$/);

export const POSTS = context.keys()
  .map((key) => context(key).default)
  .filter((post) => post && !post.isDraft)
  .map((post) => {
    const text = toPlainText(post.body);
    return {
      ...post,
      excerpt: post.excerpt || makeExcerpt(text),
      readMinutes: Math.max(1, Math.round(text.split(" ").length / WORDS_PER_MINUTE)),
      html: marked.parse(post.body.trim()),
    };
  })
  .sort((a, b) => b.date.localeCompare(a.date)); //Newest first

export const getPost = (slug) => POSTS.find((post) => post.slug === slug) || null;

export const formatPostDate = (date) => new Date(`${date}T00:00:00`).toLocaleDateString("en-ZA", {
  day: "numeric",
  month: "short",
  year: "numeric",
});
